import { useEffect, useState } from 'react';
import { Col, Row, Switch } from 'antd';

import Avatar from 'global/Avatar';
import { TargetType } from 'typings/api/shareTradeTarget';

import {
  Description,
  IconVerified,
  NameWrapper,
  UserInfoRow,
} from 'features/edit-profile/ShareTrade/UserItem/styled';
import { Text } from 'features/edit-profile/ShareTrade/styled';

interface UserItemProps {
  avatarUrl?: string;
  name?: string;
  alias?: string;
  description?: string;
  targetType?: TargetType;
  isVerified?: boolean;
  defaultSwitchValue?: boolean;
  onSwitchChange?(checked: boolean): void;
}

export default function UserItem({
  avatarUrl,
  name,
  alias,
  description,
  targetType,
  isVerified = false,
  defaultSwitchValue = false,
  onSwitchChange = () => { },
}: UserItemProps) {
  const [isSwitchChecked, setIsSwitchChecked] =
    useState<boolean>(defaultSwitchValue);

  const handleChangeSwitch = (checked: boolean) => {
    setIsSwitchChecked(checked);
    onSwitchChange(checked);
  };

  useEffect(() => {
    setIsSwitchChecked(defaultSwitchValue);
  }, [defaultSwitchValue]);

  return (
    <Row align="middle" justify="space-between">
      <Col span={22}>
        <UserInfoRow align="middle">
          <Col span={4} className="avatar-col">
            {targetType === TargetType.User && (
              <Avatar src={avatarUrl} alt={name} />
            )}
            {targetType === TargetType.ChatRoom && (
              <Avatar src={avatarUrl}>{avatarUrl ? undefined : alias}</Avatar>
            )}
          </Col>

          <Col span={20}>
            <NameWrapper align="middle">
              <Text weight="bold">{name}</Text>
              {isVerified && (
                <IconVerified src="/icon/verified.svg" alt="icon-verified" />
              )}
            </NameWrapper>
            <Description size="12px" lineHeight="16px" color="#969696">
              {description}
            </Description>
          </Col>
        </UserInfoRow>
      </Col>

      <Col span={2}>
        <Switch
          checked={isSwitchChecked}
          onChange={handleChangeSwitch}
          size="small"
        />
      </Col>
    </Row>
  );
}
